import type { SerializedConstructor } from '@langchain/core/load/serializable';

import { parseLangSmithParamsFromRun } from '@/utils/langsmith-params';

import type { ManifestPreviewProps } from '../../Manifest.utils';
import { serializedModelNameEquals } from './utils';

export const MODELS = [
  'mistral-large-latest',
  'open-mistral-nemo',
  'codestral-latest',
  'open-mistral-7b',
].map((value) => ({
  label: value,
  value,
}));

export const DEFAULT_MODEL = 'mistral-large-latest';

export function useChatMistralAIModelAndProvider(
  props: ManifestPreviewProps<SerializedConstructor>
) {
  const id = props.value.id.at(-1) ?? '';
  const kwargs = props.value.kwargs;
  const model = kwargs.model ?? DEFAULT_MODEL;

  return {
    model,
    provider: id,
  };
}

export function inferChatMistralAIManifestFromRun(
  params: ReturnType<typeof parseLangSmithParamsFromRun> | null,
  serializedModel: SerializedConstructor | null
): SerializedConstructor | null {
  if (
    !serializedModelNameEquals(serializedModel, 'ChatMistralAI') &&
    (params?.ls_provider !== 'mistral' ||
      !(params?.ls_model_type == null || params.ls_model_type === 'chat'))
  ) {
    return null;
  }

  return {
    lc: 1,
    type: 'constructor',
    id: ['langchain', 'chat_models', 'mistralai', 'ChatMistralAI'],
    kwargs: {
      ...(params?.ls_model_name !== undefined && {
        model: params.ls_model_name,
      }),
      ...(params?.ls_temperature !== undefined && {
        temperature: params.ls_temperature,
      }),
      ...(params?.ls_max_tokens !== undefined && {
        max_tokens: params.ls_max_tokens,
      }),
      client: undefined,
      async_client: undefined,
      mistral_api_key: {
        lc: 1,
        type: 'secret',
        id: ['MISTRAL_API_KEY'],
      },
    },
  };
}
